export const HEADER_TYPES = {
    CONTENT_TYPE: 'Content-Type',
    AUTHORIZATION: 'Authorization',
    ACCEPT_LANGUAGE: 'accept-language'
};
